import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

const CONFLUENCE_DATABASE_CLIENT_ID_PREFIX = 'confluence-database';

export const getConfluenceDatabaseClientId = (contentId: string): ClientId =>
	client(`${CONFLUENCE_DATABASE_CLIENT_ID_PREFIX}-${contentId}`);
